import type { CogniteClient } from '@cognite/sdk';
import { use } from 'react';

import { CogniteClientContext } from '#core/contexts/CogniteClientContext.ts';

/** Returns the CogniteClient from context. Throws if used outside CogniteClientProvider. */
export function useCogniteClient(): CogniteClient {
  const client = use(CogniteClientContext);
  if (!client) {
    throw new Error('useCogniteClient must be used within CogniteClientProvider');
  }
  return client;
}
